<div class="d-flex h-100">
  @if (link$ | async) {
    <div class="p-6 m-auto write-review-dialog d-flex flex-column" (click)="$event.stopPropagation()">
      <udex-control-button
        class="ms-auto"
        (click)="this.launchDialogService.closeDialog('Dialog close')"
        icon="decline"
        size="Large"
        design="Tertiary"
        accessible-role="Button"
        [tooltip]="'common.close' | cxTranslate"
        [attr.accessible-name]="'common.close' | cxTranslate">
      </udex-control-button>
      <div class="d-flex flex-row justify-content-center align-items-center">
        <img
          [alt]="'productReview.chatBubbleOrange' | cxTranslate"
          class="chat-bubble-orange img-responsive center-block mx-auto"
          src="/images/product/chat-bubble-icon-orange.svg" />
      </div>
      <h2 class="text-center heading__regular--s mt-5 mb-4">
        {{ headlineText$ | async }}
      </h2>
      <p class="body--s--l text-center mb-5">
        {{ 'productReview.G2CrowdRedirect' | cxTranslate }}
      </p>
      <div class="text-center">
        <a
          [href]="link$ | async"
          dcpAutofocus
          class="btn btn-primary"
          id="review-write-a-review-g2-com-link"
          rel="noopener noreferrer"
          target="_blank">
          {{ 'productReview.continueToG2Crowd' | cxTranslate }}
        </a>
      </div>
    </div>
  }
</div>
